import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox-box" }
const _hoisted_2 = ["aria-checked"]
const _hoisted_3 = ["checked"]
const _hoisted_4 = { class: "label-select" }

interface EMITS {
  (e: 'selectAll', selectAll)
}
interface PROPS {
  selectAll: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'SelectAllCheckbox',
  props: {
    selectAll: { type: Boolean }
  },
  emits: ["selectAll"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit


function allSelect(selectAll: boolean) {
  emits('selectAll', !selectAll)
}
function handleSpaceKey(event: KeyboardEvent, selectAll: boolean) {
  event.preventDefault()
  allSelect(selectAll)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      "aria-checked": _ctx.selectAll,
      class: "checkbox",
      role: "checkbox",
      tabindex: "0",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (allSelect(_ctx.selectAll))),
      onKeydown: _cache[1] || (_cache[1] = _withKeys((event) => handleSpaceKey(event, _ctx.selectAll), ["space"]))
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("label", { class: "checkbox__label" }, null, -1)),
      _createElementVNode("input", {
        checked: _ctx.selectAll,
        tabindex: "-1",
        type: "checkbox"
      }, null, 8, _hoisted_3),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "checkmark" }, null, -1))
    ], 40, _hoisted_2),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('general__data__select-all')), 1)
  ]))
}
}

})